import axiosClient from "./axiosClient";
import https from "https";

import ConstData from "../ConstData";

let options = {};

if (ConstData.IS_LOCAL_VERSION) {
    options = {
        httpsAgent: new https.Agent({
            rejectUnauthorized: false, // 허가되지 않은 인증을 reject하지 않겠다!
        })
    };
}

export const search_user = ({ userSeq, keyWord, kind, userKind }) => {
    // 관리자 계정은 제외하고 return
    let url = `/user?kind=${kind}&keyword=${keyWord}`;

    if (userSeq && userSeq >= 0) {
        url += `&userSEQ=${userSeq}`;
    }

    if (userKind) {
        url += `&userKind=${userKind}`;
    }

    return axiosClient.get(url, options);
}

export const check_sub_domain = ({ subDomainName }) => {
    // console.log("api check sub domain:) subDomainName[", subDomainName, "]");

    return axiosClient.get(`/sub-domain?kind=check-sub-domain&subDomainName=${subDomainName}`, options);
}

export const change_sub_domain_logo = ({ subDomainSeq, subDomainName, data, filename }) => {
    console.log("api change sub domain logo:) subDomainSeq[", subDomainSeq, "], subDomainName[", subDomainName, "], filename[", filename, "]");

    var form = new FormData();
    form.append("image", data, filename);

    return axiosClient.put(`/sub-domain/admin-upload/${subDomainSeq}?kind=change-logo&subDomainName=${subDomainName}`, form, options);
}

export const reset_user_login_status = ({ mode, subDomainSeq, selectedUserSeq }) => {
    console.log("api reset user login status:) mode[", mode, "], subDomainSeq[", subDomainSeq, "], selectedUserSeq[", selectedUserSeq, "]");

    return axiosClient.delete(`/sub-domain/admin/${subDomainSeq}/${selectedUserSeq}?kind=reset-login&mode=${mode}`, options);
}

export const reset_user_pw = ({ subDomainSeq, selectedUserSeq, password }) => {
    console.log("api reset user pw:) subDomainSeq[", subDomainSeq, "], selectedUserSeq[", selectedUserSeq, "], password[", password, "]");

    return axiosClient.put(`/sub-domain/admin/${subDomainSeq}?kind=reset-pw`, {        // payload 형식
        selectedUserSEQ: selectedUserSeq,
        resetPW: password
    }, options);
}

export const add_sub_domain_info = ({ userSeq, subDomainName, data, filename }) => {
    console.log("api add sub domain info:) userSeq[", userSeq, "], subDomainName[", subDomainName, "], filename[", filename, "]");

    var form = new FormData();
    form.append("image", data, filename);

    return axiosClient.post(`/sub-domain/admin-upload/${userSeq}?kind=add-sub-admin&subDomainName=${subDomainName}`, form, options);
}

export const add_sub_domain_config_admin = ({ userSeq, subDomainSeq, selectedUserSeq }) => {
    console.log("api add sub domain config admin:) userSeq[", userSeq, "], subDomainSeq[", subDomainSeq, "], selectedUserSeq[", selectedUserSeq, "]");

    return axiosClient.post(`/sub-domain/admin/${userSeq}?kind=add-configAdmin`, {        // payload 형식
        subDomainSEQ: subDomainSeq,
        selectedUserSEQ: selectedUserSeq
    }, options);
}

export const remove_sub_domain_config_admin = ({ userSeq, subDomainSeq, selectedUserSeq }) => {
    console.log("api remove sub domain config admin:) userSeq[", userSeq, "], subDomainSeq[", subDomainSeq, "], selectedUserSeq[", selectedUserSeq, "]");

    return axiosClient.delete(`/sub-domain/admin/${subDomainSeq}/${selectedUserSeq}?kind=remove-configAdmin&seq=${userSeq}`, options);
}

export const add_sub_domain_create_admin = ({ userSeq, subDomainSeq, selectedUserSeq }) => {
    console.log("api add sub domain create admin:) userSeq[", userSeq, "], subDomainSeq[", subDomainSeq, "], selectedUserSeq[", selectedUserSeq, "]");

    return axiosClient.post(`/sub-domain/admin/${userSeq}?kind=add-createAdmin`, {        // payload 형식
        subDomainSEQ: subDomainSeq,
        selectedUserSEQ: selectedUserSeq
    }, options);
}

export const remove_sub_domain_create_admin = ({ userSeq, subDomainSeq, selectedUserSeq }) => {
    console.log("api remove sub domain create admin:) userSeq[", userSeq, "], subDomainSeq[", subDomainSeq, "], selectedUserSeq[", selectedUserSeq, "]");

    return axiosClient.delete(`/sub-domain/admin/${subDomainSeq}/${selectedUserSeq}?kind=remove-createAdmin&seq=${userSeq}`, options);
}

// 아래 API 결과값에서 admin 계정은 제외하고 return 해주기.
export const get_manage_sub_domain_list_origin = ({ userSeq, subDomainName }) => {
    // console.log("api get manage sub domain list origin:) userSeq[", userSeq, "], subDomainName[", subDomainName, "]");

    return axiosClient.get(`/sub-domain/admin/${userSeq}?kind=all`, options);
}

export const get_manage_sub_domain_list = ({ userSeq }) => {
    // console.log("api get manage sub domain list:) userSeq[", userSeq, "]");

    return axiosClient.get(`/sub-domain/admin/${userSeq}?kind=all-list`, options);
}

export const get_manage_sub_domain_info = ({ subDomainSeq }) => {
    // console.log("api get manage sub domain info:) subDomainSeq[", subDomainSeq, "]");

    return axiosClient.get(`/sub-domain/admin?kind=info&subDomainSEQ=${subDomainSeq}`, options);
}

export const get_sub_domain_local_server_info = ({ subDomainSeq }) => {
    // console.log("api get sub domain local server info:) subDomainSeq[", subDomainSeq, "]");

    return axiosClient.get(`/sub-domain/admin-local/${subDomainSeq}?kind=config-list-admin`, options);
}

export const get_user_local_server_info = ({ subDomainSeq, selectedUserSeq }) => {
    console.log("api get user local server info:) subDomainSeq[", subDomainSeq, "], selectedUserSeq[", selectedUserSeq, "]");

    return axiosClient.get(`/sub-domain/admin-local/${subDomainSeq}/${selectedUserSeq}?kind=config-list-user`, options);
}

export const duplicate_check_users = ({ subDomainSeq, list_createUser }) => {
    console.log("api duplicate check users:) subDomainSeq[", subDomainSeq, "], list_createUser => ", list_createUser);

    return axiosClient.post(`/sub-domain/admin-user?kind=check`, {
        subDomainSEQ: subDomainSeq,
        list_createUser
    }, options);
}

export const create_users = ({ subDomainSeq, list_createUser }) => {
    console.log("api create users:) subDomainSeq[", subDomainSeq, "], list_createUser => ", list_createUser);

    return axiosClient.post(`/sub-domain/admin-user?kind=create`, {
        subDomainSEQ: subDomainSeq,
        list_createUser
    }, options);
}

// ---------------------------------------------------------------
// 전체 컨텐츠 선생님 목록 가져오기
// page, limit 사용하여 일부 데이터만 반환
// ---------------------------------------------------------------
export const get_all_content_teachers = ({ page = 1, limit = 9999 }) => {
    console.log("api get all content teachers:) page[", page, "], limit[", limit, "]");

    // GET 요청의 query string은 path에 직접 포함
    return axiosClient.get(`/admin/teacher?page=${page}&limit=${limit}`, options);
}

// ---------------------------------------------------------------
// 컨텐츠 선생님 일괄 생성
// list_teacher: [{ teacherName, useYn? }, ...]
// ---------------------------------------------------------------
export const create_content_teachers = ({ list_teacher }) => {
    console.log("api create content teachers:) list_teacher => ", list_teacher);

    return axiosClient.post("/admin/teacher", {
        list_teacher
    }, options);
}

// ---------------------------------------------------------------
// 컨텐츠 선생님 사용 여부 업데이트
// PUT /admin/teacher/use/:teacherSeq  { useYn: "Y" | "N" }
// ---------------------------------------------------------------
export const update_content_teacher_use_yn = ({ teacherSeq, useYn }) => {
    console.log("api update content teacher use yn:) teacherSeq[", teacherSeq, "], useYn[", useYn, "]");

    return axiosClient.put(`/admin/teacher/use/${teacherSeq}`, {
        useYn
    }, options);
}

// ---------------------------------------------------------------
// 컨텐츠 선생님 이름 업데이트
// PUT /admin/teacher/name/:teacherSeq  { teacherName }
// ---------------------------------------------------------------
export const update_content_teacher_name = ({ teacherSeq, teacherName }) => {
    console.log("api update content teacher name:) teacherSeq[", teacherSeq, "], teacherName[", teacherName, "]");

    return axiosClient.put(`/admin/teacher/name/${teacherSeq}`, {
        teacherName
    }, options);
}

// ---------------------------------------------------------------
// 컨텐츠 선생님 정보 업데이트 (이름 + 사용여부 동시)
// PUT /admin/teacher/info/:teacherSeq  { teacherName, useYn }
// ---------------------------------------------------------------
export const update_content_teacher_info = ({ teacherSeq, teacherName, useYn }) => {
    console.log("api update content teacher info:) teacherSeq[", teacherSeq, "], teacherName[", teacherName, "], useYn[", useYn, "]");

    return axiosClient.put(`/admin/teacher/info/${teacherSeq}`, {
        teacherName,
        useYn
    }, options);
}

// ---------------------------------------------------------------
// 컨텐츠 선생님 삭제
// DELETE /admin/teacher/:teacherSeq
// ---------------------------------------------------------------
export const delete_content_teacher = ({ teacherSeq }) => {
    console.log("api delete content teacher:) teacherSeq[", teacherSeq, "]");

    return axiosClient.delete(`/admin/teacher/${teacherSeq}`, options);
}

// ---------------------------------------------------------------
// 전체 라이브 목록 가져오기 (관리자용)
// page, limit 사용하여 일부 데이터만 반환
// ---------------------------------------------------------------
export const get_all_live_list = ({ page = 1, limit = 9999 }) => {
    console.log("api get all live list:) page[", page, "], limit[", limit, "]");

    return axiosClient.get(`/admin/live?page=${page}&limit=${limit}`, options);
}

// ---------------------------------------------------------------
// 라이브 정보 업데이트 (관리자용)
// PUT /admin/live/:liveSEQ?kind=update  { liveName, useYn }
// ---------------------------------------------------------------
export const update_live_info = ({ liveSeq, liveName, useYn }) => {
    console.log("api update live info:) liveSeq[", liveSeq, "], liveName[", liveName, "], useYn[", useYn, "]");

    return axiosClient.put(`/admin/live/${liveSeq}?kind=update`, {
        liveName,
        useYn
    }, options);
}

// ---------------------------------------------------------------
// 라이브 삭제 (관리자용)
// PUT /admin/live/:liveSEQ?kind=delete  (실제 삭제가 아닌 LIVE_DEL_YN='Y' 처리)
// ---------------------------------------------------------------
export const delete_live = ({ liveSeq }) => {
    console.log("api delete live:) liveSeq[", liveSeq, "]");

    return axiosClient.put(`/admin/live/${liveSeq}?kind=delete`, {
        deleteYn: "Y"
    }, options);
}

// ---------------------------------------------------------------
// 고정 URL 전체 목록 조회
// GET /admin/url?page=1&limit=9999
// ---------------------------------------------------------------
export const get_all_content_urls = ({ page = 1, limit = 9999 }) => {
    console.log("api get all content urls:) page[", page, "], limit[", limit, "]");

    return axiosClient.get("/admin/url", {
        ...options,
        params: { page, limit }     // → /admin/url?page=1&limit=9999
    });
}

// ---------------------------------------------------------------
// 고정 URL 일괄 생성
// POST /admin/url
// list_url: [{ siteName, siteAddress, faviconUrl? }, ...]
//   → faviconUrl은 NULL 허용이므로 없어도 됨
// ---------------------------------------------------------------
export const create_content_urls = ({ list_url }) => {
    console.log("api create content urls:) list_url => ", list_url);

    return axiosClient.post("/admin/url", {
        list_url
    }, options);
}

// ---------------------------------------------------------------
// 고정 URL 정보 업데이트 (사이트명 + 사이트주소 + 파비콘URL + 사용여부 동시)
// PUT /admin/url/:urlSeq  { siteName, siteAddress, faviconUrl, useYn }
//   → modules/admin.js의 UPDATE_URL_INFO_SUCCESS에서
//     action.parms.urlSeq 로 꺼내기 때문에 파라미터명을 urlSeq로 통일
// ---------------------------------------------------------------
export const update_content_url_info = ({ urlSeq, siteName, siteAddress, faviconUrl, useYn }) => {
    console.log("api update content url info:) urlSeq[", urlSeq, "], siteName[", siteName, "], siteAddress[", siteAddress, "], faviconUrl[", faviconUrl, "], useYn[", useYn, "]");

    return axiosClient.put(`/admin/url/${urlSeq}`, {
        siteName,
        siteAddress,
        faviconUrl,
        useYn
    }, options);
}

// ---------------------------------------------------------------
// 고정 URL 삭제
// DELETE /admin/url/:urlSeq
//   → modules/admin.js의 DELETE_CONTENT_URL_SUCCESS에서
//     action.parms.urlSeq 로 꺼냄
// ---------------------------------------------------------------
export const delete_content_url = ({ urlSeq }) => {
    console.log("api delete content url:) urlSeq[", urlSeq, "]");

    return axiosClient.delete(`/admin/url/${urlSeq}`, options);
}

// ---------------------------------------------------------------
// URL 메타 데이터 가져오기
// GET /content/url-meta?url=:url
// ---------------------------------------------------------------
export const get_url_meta = ({ url }) => {
    // 260731 URL 내부의 &, #, 한글 경로가 손상되지 않도록 params로 전달
    return axiosClient.get('/content/url-meta', {
        ...options,
        params: { url }
    });
}

// ---------------------------------------------------------------
// 260805 관리자 MEDIA 탭용 - 미디어 수프 게이트웨이 서버 전체 목록 조회
// GET /mediagateway/list
// ---------------------------------------------------------------
export const get_media_gateway_list = () => {
    return axiosClient.get(`/mediagateway/list`, options);
}
